import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales/es-es'
import { FRONT_DF_1 } from 'CONST';
import store from '../redux-store/store/index';

numeral.locale('es-es');

export const setFontSize = (num) => {
  const string = num.toString();
  const fontSize = string.length > 12 ? 36 - 3 * (12 / 2) : 36;
  return `${fontSize}px`;
};

export const fileDownload = (downloadUrl, id, method = 'GET', body = null, handleLoading) => {
  const { login } = store.getState();
  const xhr = new XMLHttpRequest();
  xhr.open(method, `${downloadUrl}${id}`, true);
  xhr.responseType = 'blob';
  xhr.setRequestHeader('Authorization', `JWT ${login.id_token}`);
  xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  xhr.onload = function onload() {
    if (this.status === 200) {
      const content = xhr.getResponseHeader('Content-Disposition');
      let filename = '';
      if (content.includes('filename=')) {
        filename = content.split('filename=')[1].replace(/^"+|"+$/g, '');
      } else {
        filename = decodeURI(content.split("filename*=utf-8''")[1].replace(/^"+|"+$/g, ''));
      }
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(new Blob([this.response]));
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 1000);
    }
    if (handleLoading) {
      handleLoading();
    }
  };

  xhr.send(body);
};

export const roundFloat = (value, decimals = 2) => {
  const format = '0,0.'.padEnd(decimals + 4, '0');
  const safeValue = value < 1e-6 ? 0 : value;
  return numeral(safeValue).format(format);
};

export const roundInt = (value) => (numeral(value).format());

export const formatNumber = (value, decimals = 2) =>
  Number.isInteger(value) ? roundInt(value) : roundFloat(value, decimals);

export const formatSpanishNumber = (num) => {
  // Convert number to spanish formatted number
  // Ej: 23457.2 to "23.457,2"
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts.join(',');
}

export const fdate = (date, format = FRONT_DF_1) => (date ? moment(date).format(format) : '');

export function sanitizeRut(rut) {
  return rut.replace(/[^\dk]/gi, '');
}

function internalFormatRut(rawRut) {
  const sanitizedRut = sanitizeRut(rawRut);
  const body = sanitizedRut.slice(0, -1);
  const dv = sanitizedRut.slice(-1).toUpperCase();
  const formatted = `${body.replace(/(?!^)(\d{3})(?=(?:\d{3})*$)/g, '.$1')}-${dv}`;
  return { sanitizedRut, body, dv, formatted };
}

export function formatRut(rawRut) {
  if (!rawRut) {
    return '';
  }
  return internalFormatRut(rawRut).formatted;
}

export const bytesToMb = (number) => (number / 1024 / 1024).toFixed(2);

export const mbToBytes = (number) => number * 1024 * 1024;


export const parseTiempoEspera = (value) => {
  if (!value) return 0;
  const hoursMatch = value.match(/(\d+)h/);
  const minsMatch = value.match(/(\d+)min/);

  const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
  const mins = minsMatch ? parseInt(minsMatch[1], 10) : 0;

  return hours + mins / 60;
};

export const getUrgencyColor = (hours) => {
  if (hours >= 48) return "red";
  if (hours >= 24) return "gold";
  return "green";
};
